export const orderDetails = {
    header: 'Suivre la commande',
    quote: 'Offre',
    subHeader: 'Détails',
    hasBeenShipped: 'Cette commande a déjà été effectuée',
    orderSummary: 'Résumé de la commande',
    labels: {
        shippingMethod: 'Livraison',
        orderNumber: 'Numéro de commande',
        quoteNumber: "Numéro de l'offre",
        createdAt: 'Commandé(e)',
        quoteCreatedAt: 'Demande',
        orderStatus: 'Statut de la commande',
        productionTime: 'Délai de production',
        deliveryTime: 'Délai de livraison prévu',
        deliveryTimeShort: "Délai d'envoi prévu",
        deliveryAndProductionTime: 'Délai de livraison total estimé',
        shippingAddress: 'Adresse de livraison',
        billingAddress: 'Adresse de facturation',
        name: 'Nom',
        email: 'Adress e-mail',
        address: 'Adresse',
        city: 'Ville',
        country: 'Pays',
        paymentMethod: 'Mode de paiement',
        items: 'Articles',
        summary: 'Résumé',
        positionPrice: 'Prix total (sans frais de livraison)',
        shippingPrice: 'Frais de livraison',
        amountTotal: 'Montant Total',
        cartSum: 'Somme',
    },
    businessDays: '0 jour ouvert | 1 jour ouvert | {n} jours ouverts',
    regularDays: '0 jour | 1 jour | {n} jours ',
    actions: {
        reOrder: 'Commander à nouveau',
        payNow: 'Payer maintenant',
        orderNow: 'Commandez maintenant',
    },
    reOrderModal: {
        headline: 'Voulez-vous commander à nouveau la commande {orderNumber} ?',
        nItems: '0 pièce | une pièce | {n} pièces',
    },
};
